import * as React from "react";
import { IInitialState, DataContext, ScreenView } from '../../../models/chat.models';
import { WebChatHeaderWelcome } from './header-welcome/header-welcome';
import { WebChatHeaderContent } from './header-chat/header-chat';

var Color = require('color');

export interface WebChatHeaderProps { }

export const WebChatHeader = (props: WebChatHeaderProps) => {
    
  const context: IInitialState = React.useContext(DataContext);

  const cssContent = require('./header.css').toString();
  let personalizedCss = '';

  if (context.webChatSettings && context.webChatSettings.MainColour) {
    const mainColor = Color(context.webChatSettings.MainColour).rgb().string();
    const lighthenMainColor = Color(context.webChatSettings.MainColour).lighten(0.3).rgb().string();
    
    personalizedCss = '\
    .help-desk-messenger-header {\
      background: linear-gradient(135deg, ' + mainColor + ' 0%, ' + lighthenMainColor + ' 100%); \
    }';
  }
  
  return (
    <div className="help-desk-messenger-header" style={ context.screenView == ScreenView.Welcome ? { height: 'auto'} : context.screenView == ScreenView.Chat ? { height: '160px'} : { height: 'auto'} }>
      <style>
        {cssContent}
        {personalizedCss}
      </style>
      <div>
        <div className="help-desk-messenger-header-wrapper">
          { context.screenView == ScreenView.Welcome && <WebChatHeaderWelcome /> }
          { context.screenView == ScreenView.Chat && <WebChatHeaderContent /> }
          { context.screenView == ScreenView.VoiceChat && <WebChatHeaderContent /> }
        </div>
      </div>
    </div>
  )
}